var React = require('react');

function MultiImage (props) {
    return React.createElement("svg",props,React.createElement("g",{"transform":"matrix(1,0,0,1,-991.151,-610.283)"},React.createElement("g",{"transform":"matrix(1,0,0,1,989.151,608.283)"},React.createElement("path",{"d":"M20,4L20,16L8,16L8,4L20,4M20,2L8,2C6.9,2 6,2.9 6,4L6,16C6,17.1 6.9,18 8,18L20,18C21.1,18 22,17.1 22,16L22,4C22,2.9 21.1,2 20,2ZM11.5,11.67L13.19,13.93L15.67,10.83L19,15L9,15L11.5,11.67ZM2,6L2,20C2,21.1 2.9,22 4,22L18,22L18,20L4,20L4,6L2,6Z","style":{"fill":"white","fillRule":"nonzero"}}))));
}

MultiImage.defaultProps = {"width":"100%","height":"100%","viewBox":"0 0 20 20","version":"1.1","xmlSpace":"preserve","style":{"fillRule":"evenodd","clipRule":"evenodd","strokeLinejoin":"round","strokeMiterlimit":"2"}};

module.exports = MultiImage;

MultiImage.default = MultiImage;
